<template>
	<div>
<!-- 		<div class="container-wrapper search-row-container-wrapper">
			<div class="search-row-container container wide">
				<div class="search-row">
					<div class="search-row__search-bar search-bar-col no-advance-search">
						<b-input-group>
							<b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal"/>
							<b-input-group-append class="vdp-datepicker__search-button">
								<button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
							</b-input-group-append>
							<b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch">
								<button type="button" class="btn" @click="clearSearch();searchGlobal()">&times;</button>
							</b-input-group-append>
						</b-input-group>
					</div>
				</div>
			</div>
		</div> -->

		<div class="quick-switch-container-wrapper">
			<div class="quick-switch-container container wide">
				<div class="quick-switch hide-mobile">
					<div class="quick-switch__title-standalone" v-html="title"></div>
					<button v-if="showNewScheduleButton" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:newschedule')">
						New Schedule
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import NotificationSchedule from './../models/NotificationSchedule'
import BootstrapField from './../utility/BootstrapField';
import moment from 'moment-timezone';
import Format from './../utility/Format';


export default {
	name: 'NotificationScheduleFilters',
	components: {
	},
	props: {
		columns: Array,
		totals: Object,
		activeList: Number,
		callOptionMethod: String,
		storeArgs:String,
		storeModule:String,
		showNewScheduleButton:Boolean,
	},
	data: () => ({
		showAdvancedSearch: false,
		showLaneFilter: false,
		arg: {},
		globalSearch: null,
		NotificationSchedule,
		filterCompleted: new BootstrapField({
				value: 0,
			}),
	}),
	mounted() {
		this.getAdvancedSearch();
	},
	created() {
		if ( this.columns ) {
			this.columns.forEach(item => {
				if ( item.filter ) {
					if ( item.filter.autoComplete && item.filter.show ) {
						this.getArgs(item.filter)
					}
				}
			})
		}
	},

	computed: {
		title() {
			return "Notification Schedule";
		},
		Totals() {
			let lists = []
			for (let item in this.totals) {
				if (item == "closures") {
					let attr = [],
						total = 0
					for (let key in this.totals[item]) {
						attr.push({
							name: key,
							count: parseInt(this.totals[item][key])
						})
						total += parseInt(this.totals[item][key])
					}
					lists.push({
						taskName: item,
						total,
						status: attr
					})
				}
			}
			return lists
		}
	},
	methods: {
		getAdvancedSearch() {
		    this.showAdvancedSearch = false;
		},
		parseLabel(node, argAttr) {
			if ( node.label ) {
				if ( node.label.indexOf('(unknown)') > -1 ) {
					node.label = this.arg[argAttr]
				} else {
					this.arg[argAttr] = node.label
				}
			}
			return node.label
		},


		searchGlobal() {
			this.arg['keywords'] = this.globalSearch
			this.setArgs()
			this.$emit('submit:filters')
		},

		getArgValues(keyField, label) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeFilter))
			if (argQuery == null) {
				argQuery = {};
			}

			if (argQuery != null) {
			if ( !Array.isArray(argQuery) ) {
				if ( argQuery[keyField] ) {
					this.arg[keyField] = argQuery[keyField]
				}
			}
			if ( !this.arg[keyField] ) {
				this.arg[keyField] = {}
				if ( label ) {
					this.arg[keyField][label] = ''
				}
			}
			}
		},


		clearArgs( filters ) {
			this.arg = {
				...this.arg,
				[filters.key]: null,
				[filters.key+'_label']: null
			}
		},
		getArgs( filters ) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
			}
			if ( filters.autoComplete ) {
				this.arg = {
					...this.arg,
					[filters.key]: argQuery[filters.key]
				}
			} else if ( filters.datePicker ) {
				let startMoment = null;
				let endMoment = null;
				if (argQuery[filters.datePicker.from] != undefined) {
					startMoment = this.moment(argQuery[filters.datePicker.from]);
					if (startMoment.isValid()) {
					    startMoment.hours(0);
					    startMoment.minutes(0);
					    startMoment.seconds(0);
				this.arg = {
					...this.arg,
						    [filters.datePicker.from]: startMoment.format(),
						}
						this.filterDate.startDate = new Date(startMoment.format());
					} else {
						argQuery[filters.datePicker.from] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datePicker.from]: null,
						}
						this.filterDate.startDate = null;
					}
				}
				if (argQuery[filters.datePicker.to] != undefined) {
					endMoment = this.moment(argQuery[filters.datePicker.to]);
					if (endMoment.isValid()) {
					    endMoment.hours(23);
					    endMoment.minutes(59);
					    endMoment.seconds(59);
					    this.arg = {
					        ...this.arg,
					        [filters.datePicker.to]: endMoment.format(),
					    }
					    this.filterDate.endDate = new Date(endMoment.format());
					} else {
						argQuery[filters.datePicker.to] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datePicker.to]: null,
						}
						this.filterDate.endDate = null;
					}
				}
			}
			// pull in the global search and completed request filter.
			if (argQuery != null) {
				if (argQuery.keywords) {
					this.globalSearch = argQuery.keywords;
				} else {
					this.globalSearch = null;
				}
				this.arg = argQuery;
			}

		},
		setArgs() {
			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
			this.$emit('submit:filters')
		},
		resetArgs() {
			this.arg = Array()
			this.globalSearch = "";
			this.$store.dispatch(this.storeModule+'/clearParams');
			this.columns.map(elem => {
				if (elem.filter != undefined ) {
					if (elem.filter.show) {
						this.clearArgs(elem.filter)
					}
				}
			})
			this.setArgs()
			this.showAdvancedSearch = false
			this.setArgs();
			this.showAdvancedSearch = false;
			this.saveAdvancedSearch();
		},

		onDatePickerChange(input, keyField) {
			let dateString = null;

				if (input) {
						let theDate = moment.tz({
								year: input.getFullYear(),
								month: input.getMonth(),
								day: input.getDate(),
								hour: keyField == "toDate" ? 23 : 0,
								minute: keyField == "toDate" ? 59 : 0,
								second: keyField == "toDate" ? 59 : 0
						}, Format.TIMEZONE);

			if (theDate.isValid()) {
								dateString = theDate.utc().format();
				}
			}

			this.arg = {
				...this.arg,
				[keyField]: dateString
			}



		},
		clearSearch() {
			this.globalSearch = null;
			// this.searchGlobal();
		},

	}
}
</script>
